import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import BackButton from "../common/BackButton";

export default function LoginHelpMobile() {
  const history = useHistory();
  const isNarrowScreen = window.innerWidth <= 360;
  const countyName = useSelector((state) => state.countyConfigCommonReducer.countyName);
  const appTitle = useSelector((state) => state.countyConfigCommonReducer.appTitle);

  const handleForgotUsernameClick = () => {
    history.push("/forgotUsernameMobile");
  };

  const handleForgotPasswordClick = () => {
    history.push("/forgotPasswordMobile");
  };

  return (
    <div>
      {/* Banner */}
      <div style={styles.banner}>
        <div style={styles.logoContainer}>
          <BackButton onClick={() => history.push("/login")} ariaLabel="Back to login" />
        </div>

        <div style={styles.titleContainer}>
          <div
            style={{
              ...styles.title,
              fontSize: isNarrowScreen ? "16px" : "20px",
            }}
          >
            {countyName}
          </div>
          <div
            style={{
              ...styles.subtitle,
              fontSize: isNarrowScreen ? "13px" : "16px",
            }}
          >
            {appTitle}
          </div>
        </div>

        <div style={styles.right} />
      </div>

      {/* Content */}
      <div style={styles.content}>
        <h2
          style={{
            ...styles.pageTitle,
            fontSize: isNarrowScreen ? "18px" : "20px",
          }}
        >
          Login Help
        </h2>

        <div style={styles.optionList}>
          <button style={styles.optionButton} onClick={handleForgotUsernameClick}>
            Forgot Username
          </button>
          <button style={styles.optionButton} onClick={handleForgotPasswordClick}>
            Forgot Password
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    alignItems: "center",
    backgroundColor: "#114E6B",
    color: "white",
    padding: "14px 16px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    boxSizing: "border-box",
    overflowX: "hidden",
    zIndex: 1000,
  },

  logoContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  titleContainer: {
    marginLeft: "8px",
    textAlign: "left",
  },

  title: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "1.2",
    color: "white",
  },

  subtitle: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    opacity: 0.9,
    color: "white",
  },

  right: {
    justifySelf: "end",
    width: "40px",
  },

  content: {
    marginTop: "70px",
    padding: "16px",
  },

  pageTitle: {
    marginBottom: "20px",
    color: "#114E6B",
  },

  optionList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  optionButton: {
    background: "none",
    border: "none",
    padding: 0,
    color: "#114E6B",
    textDecoration: "underline",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "left",
  },
};
